// GENERATED by src/_console/bwaSchemaExport.js -s 3 from src/_console/skr/BWA-Schema_SKR_03.xlsx - do not edit by hand
import type { BwaSchemaRow } from "./bwaSchema";

export const BWA_SCHEMA_SKR03: readonly BwaSchemaRow[] = [
    {
        zeile: 1020,
        kennz: null,
        label: "Umsatzerlöse",
        nature: "ertrag",
        ranges: [
            [2750, 2752],
            [2764, 2764],
            [8000, 8599],
            [8700, 8799],
        ],
    },
    { zeile: 1040, kennz: null, label: "Bestandsveränderung FE/UE", nature: "ertrag", ranges: [[8960, 8989]] },
    { zeile: 1045, kennz: null, label: "Aktivierte Eigenleistungen", nature: "ertrag", ranges: [[8990, 8999]] },
    {
        zeile: 1051,
        kennz: "A",
        label: "Gesamtleistung",
        nature: "ertrag",
        formula: [
            { zeile: 1020, sign: 1 },
            { zeile: 1040, sign: 1 },
            { zeile: 1045, sign: 1 },
        ],
    },
    {
        zeile: 1060,
        kennz: null,
        label: "Material-/Wareneinkauf",
        nature: "aufwand",
        ranges: [
            [3000, 3969],
            [4000, 4099],
        ],
    },
    {
        zeile: 1080,
        kennz: "B",
        label: "Rohertrag",
        nature: "ertrag",
        formula: [
            { zeile: 1051, sign: 1 },
            { zeile: 1060, sign: -1 },
        ],
    },
    {
        zeile: 1090,
        kennz: null,
        label: "Sonstige betriebliche Erlöse",
        nature: "ertrag",
        ranges: [
            [2705, 2706],
            [2749, 2749],
            [8600, 8649],
            [8900, 8959],
        ],
    },
    {
        zeile: 1092,
        kennz: "C",
        label: "Betrieblicher Rohertrag",
        nature: "ertrag",
        formula: [
            { zeile: 1080, sign: 1 },
            { zeile: 1090, sign: 1 },
        ],
    },
    {
        zeile: 1100,
        kennz: null,
        label: "Personalkosten",
        nature: "aufwand",
        ranges: [
            [4100, 4199],
            [4990, 4990],
            [4995, 4995],
        ],
    },
    {
        zeile: 1120,
        kennz: null,
        label: "Raumkosten",
        nature: "aufwand",
        ranges: [
            [4200, 4299],
            [4991, 4991],
        ],
    },
    {
        zeile: 1140,
        kennz: null,
        label: "Betriebliche Steuern",
        nature: "aufwand",
        ranges: [
            [2285, 2299],
            [2375, 2379],
            [4320, 4359],
        ],
    },
    {
        zeile: 1150,
        kennz: null,
        label: "Versicherungen, Beiträge und Abgaben",
        nature: "aufwand",
        ranges: [[4360, 4399]],
    },
    {
        zeile: 1160,
        kennz: null,
        label: "Besondere Kosten",
        nature: "aufwand",
        ranges: [
            [2400, 2429],
            [2440, 2451],
            [4400, 4499],
        ],
    },
    { zeile: 1180, kennz: null, label: "Fahrzeugkosten (ohne Steuer)", nature: "aufwand", ranges: [[4500, 4599]] },
    { zeile: 1200, kennz: null, label: "Werbe- und Reisekosten", nature: "aufwand", ranges: [[4600, 4699]] },
    { zeile: 1220, kennz: null, label: "Kosten Warenabgabe", nature: "aufwand", ranges: [[4700, 4799]] },
    {
        zeile: 1240,
        kennz: null,
        label: "Abschreibungen",
        nature: "aufwand",
        ranges: [
            [4820, 4869],
            [4886, 4899],
            [4993, 4993],
        ],
    },
    { zeile: 1250, kennz: null, label: "Reparaturen und Instandhaltungen", nature: "aufwand", ranges: [[4800, 4809]] },
    {
        zeile: 1260,
        kennz: null,
        label: "Sonstige Kosten",
        nature: "aufwand",
        ranges: [
            [2170, 2199],
            [2380, 2399],
            [4300, 4319],
            [4810, 4819],
            [4900, 4974],
            [4980, 4989],
            [4992, 4992],
            [4994, 4994],
        ],
    },
    {
        zeile: 1280,
        kennz: "D",
        label: "Gesamtkosten",
        nature: "aufwand",
        formula: [
            { zeile: 1100, sign: 1 },
            { zeile: 1120, sign: 1 },
            { zeile: 1140, sign: 1 },
            { zeile: 1150, sign: 1 },
            { zeile: 1160, sign: 1 },
            { zeile: 1180, sign: 1 },
            { zeile: 1200, sign: 1 },
            { zeile: 1220, sign: 1 },
            { zeile: 1240, sign: 1 },
            { zeile: 1250, sign: 1 },
            { zeile: 1260, sign: 1 },
        ],
    },
    {
        zeile: 1300,
        kennz: "E",
        label: "Betriebsergebnis",
        nature: "ertrag",
        formula: [
            { zeile: 1092, sign: 1 },
            { zeile: 1280, sign: -1 },
        ],
    },
    { zeile: 1310, kennz: null, label: "Zinsaufwendungen", nature: "aufwand", ranges: [[2100, 2149]] },
    {
        zeile: 1312,
        kennz: null,
        label: "Sonstiger neutraler Aufwand",
        nature: "aufwand",
        ranges: [
            [2000, 2099],
            [2150, 2169],
            [2300, 2374],
            [2430, 2439],
            [2452, 2479],
            [2490, 2494],
            [4870, 4885],
            [4975, 4979],
        ],
    },
    {
        zeile: 1320,
        kennz: "F",
        label: "Neutraler Aufwand",
        nature: "aufwand",
        formula: [
            { zeile: 1310, sign: 1 },
            { zeile: 1312, sign: 1 },
        ],
    },
    {
        zeile: 1322,
        kennz: null,
        label: "Zinserträge",
        nature: "ertrag",
        ranges: [
            [2650, 2699],
            [8650, 8699],
        ],
    },
    {
        zeile: 1323,
        kennz: null,
        label: "Sonstiger neutraler Ertrag",
        nature: "ertrag",
        ranges: [
            [2500, 2599],
            [2600, 2649],
            [2700, 2704],
            [2707, 2748],
            [2753, 2763],
            [2765, 2789],
            [2790, 2794],
            [8800, 8899],
        ],
    },
    { zeile: 1324, kennz: null, label: "Verrechnete kalkulatorische Kosten", nature: "ertrag", ranges: [[2890, 2895]] },
    {
        zeile: 1330,
        kennz: "G",
        label: "Neutraler Ertrag",
        nature: "ertrag",
        formula: [
            { zeile: 1322, sign: 1 },
            { zeile: 1323, sign: 1 },
            { zeile: 1324, sign: 1 },
        ],
    },
    {
        zeile: 1340,
        kennz: null,
        label: "Kontenklasse unbesetzt",
        nature: "ertrag",
        ranges: [
            [2480, 2489],
            [2495, 2499],
            [2795, 2799],
            [2800, 2889],
            [2896, 2999],
            [3970, 3999],
            [4996, 4999],
        ],
    },
    {
        zeile: 1345,
        kennz: "H",
        label: "Ergebnis vor Steuern",
        nature: "ertrag",
        formula: [
            { zeile: 1300, sign: 1 },
            { zeile: 1320, sign: -1 },
            { zeile: 1330, sign: 1 },
            { zeile: 1340, sign: 1 },
        ],
    },
    {
        zeile: 1355,
        kennz: null,
        label: "Steuern vom Einkommen und vom Ertrag",
        nature: "aufwand",
        ranges: [[2200, 2284]],
    },
    {
        zeile: 1380,
        kennz: "I",
        label: "Vorläufiges Ergebnis",
        nature: "ertrag",
        formula: [
            { zeile: 1345, sign: 1 },
            { zeile: 1355, sign: -1 },
        ],
    },
];
